import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import OrganizerIdea from './OrganizerIdea';
import PaidFeatureLock from '../components/PaidFeatureLock';
import { venueLocked, venueLockReason } from '../lib/entitlements';
import '../styles/demands.css';

export default function VenueIdea() {
  const { user } = useAuth();
  // A6: mekânın fikir üretimi ücretli + onaylı mekân hakkı. Kademe biliniyorsa kilit kartı baştan gösterilir; eski
  // oturumda sunucu 403 VENUE_PAID_REQUIRED / VENUE_APPROVAL_REQUIRED dönerse aynı karta düşülür.
  const [serverLock, setServerLock] = useState(null);
  const reason = serverLock || (venueLocked(user, 'idea_generate') ? (venueLockReason(user) || 'paid') : null);
  if (reason) return <section className="demand-page">
    <div className="demand-heading"><div><p className="demand-eyebrow">Mekânın için</p><h1>Fikirlerim</h1><p>Mekânına uygun etkinlik fikirlerini Meko ile geliştir.</p></div></div>
    <PaidFeatureLock feature="Mekânına uygun fikir üretimi" reason={reason} />
  </section>;
  return <OrganizerIdea key={user.id} role="venue" ownerId={user.id} onLocked={setServerLock} />;
}
